/* CK Swim-Spa-Finder (P018, XXL ab P020): eigener Cover-Finder für Swim-Spa-Cover nach Maß – Cover-Art, Maße, Material & Farbe, Schürze.
   Grenzen und Zusatz-Produkte wie in den bisherigen Easify-Optionen. Farben und Schürzen kommen als eigene Positionen in den Warenkorb. */
(function () {
  'use strict';
  var SVGNS = 'http://www.w3.org/2000/svg';
  var IMG = 'https://cdn.shopify.com/s/files/1/0630/0555/6964/files/';
  var MATS = [
    { key: 'mv', name: 'Marine Vinyl', group: 'Marine Venyl Farben', prop: '_Venyl Farbe', price: 0, crop: '&crop=region&crop_left=40&crop_top=40&crop_width=240&crop_height=240',
      desc: 'UV- und schimmelbeständig, 8 Farben.', def: 1,
      colors: [
        ['Grau 005', 45509450825995, 'Cover-King-005_55a1fc64-7080-452f-8930-dc9a103cb3d0.png?v=1713366235'],
        ['Anthrazit 004', 45509465243915, 'Cover-King-004_bba33a10-c4cb-453b-b941-375ba37e4b27.png?v=1713366239'],
        ['Schwarz 033', 45509473304843, 'Cover-King-033_2ee48d23-f3cd-401d-b0b0-530e8021cdc0.png?v=1713366243'],
        ['Braun 001', 45509505122571, 'Cover-King-001_0a67e426-caf9-4211-8f60-91512c1072e7.png?v=1713366259'],
        ['Bourbon 007', 45509499945227, 'Cover-King-007_63da3ab9-bfa1-4659-8b6b-cb3e84effa48.png?v=1713366254'],
        ['Dunkelbraun 002', 45509509153035, 'Cover-King-002_d78d6eca-b9fb-4e22-b72d-9e4b6c0fc995.png?v=1713366266'],
        ['Blau 008', 45509480808715, 'Cover-King-008_34bd5772-d751-4958-8daf-e8ae7c45ca42.png?v=1713366249'],
        ['Creme 036', 45509516525835, 'Cover-King-036_f3d1dcc0-d71d-47e7-9ae2-95bdece27893.png?v=1713366271']
      ] },
    { key: 'ws', name: 'Weathershield', group: 'Weather Shield Farben', prop: '_Weather Shield Farben', price: 16000, crop: '&crop=region&crop_left=400&crop_top=400&crop_width=440&crop_height=440',
      desc: 'Unser Premium-Material, besonders robust und langlebig.', badge: 'Empfehlung', def: 0,
      colors: [
        ['Weather Shield Anthrazit W4', 51232762200331, 'Anthrazit-W4.png?v=1744205388'],
        ['Weather Shield Schwarz W3', 51232776257803, 'black-W3.png?v=1744205387'],
        ['Weather Shield Dunkelbraun W2', 51232803520779, 'Darkbrown-W2.png?v=1744205388']
      ] }
  ];
  var SKIRTS = [
    ['Schürzenlänge 15 cm (Standard)', '15 cm (Standard)', 45555770392843, 0],
    ['0 cm', 'ohne (0 cm)', 45555794542859, 4000],
    ['5 cm', '5 cm', 49626914062603, 4000],
    ['7,5 cm', '7,5 cm', 49626916847883, 4000],
    ['10 cm', '10 cm', 45555791102219, 4000],
    ['20 cm', '20 cm', 45555792511243, 4000],
    ['30 cm', '30 cm', 45555793297675, 8900]
  ];
  // Zusatz-Produkte: Preise werden live aus dem Shop geladen (richtiger Markt-Preis); die Zahlen oben sind nur Startwerte.
  var HANDLES = ['schurzenlange', 'ohne-schurzenlange-0-cm', 'schurzenlange-5-cm', 'schurzenlange-7-5-cm', 'schurzenlange-10-cm', 'schurzenlange-20-cm', 'schurzenlange-30-cm', 'weather-shield-tan-kopie', 'weather-shield-tan-kopie-kopie', 'weather-shield-dunkelbraun'];
  var NAMES = { s2: ['2-teilig', 'Für Swim Spas von 320 bis 500 cm Länge'], s3: ['3-teilig', 'Für Swim Spas von 460 bis 690 cm Länge'], z2: ['2 Zonen, 3-teilig', 'Swim-Spa-Bereich und Whirlpool, 460 bis 690 cm'], x2: ['XXL 2-teilig', 'Für große Whirlpools von 250 bis 379 cm Länge'] };
  var MODES = {
    s2: { parts: 2, fields: [['a', 'Seite A', 'Breite', 150, 239], ['b', 'Seite B', 'Länge', 320, 500], ['r', 'Eckradius r', '', 0, 60]], demo: { a: 230, b: 450, r: 18 } },
    s3: { parts: 3, fields: [['a', 'Seite A', 'Breite', 180, 260], ['b', 'Seite B', 'Länge', 460, 690], ['r', 'Eckradius r', '', 0, 60]], demo: { a: 230, b: 600, r: 18 }, wideFrom: 236 },
    x2: { parts: 2, fields: [['a', 'Seite A', 'Breite', 160, 239], ['b', 'Seite B', 'Länge', 250, 379], ['r', 'Eckradius r', '', 0, 60]], demo: { a: 230, b: 320, r: 18 } },
    z2: { parts: 3, fields: [['a', 'Seite A', 'Breite', 180, 239], ['b', 'Seite B', 'Swim-Spa-Bereich', 200, 690], ['c', 'Seite C', 'Whirlpool-Bereich', 100, 240], ['r', 'Eckradius r', '', 0, 60]], demo: { a: 230, b: 380, c: 210, r: 18 }, total: [460, 690] }
  };

  function el(tag, cls, text) { var e = document.createElement(tag); if (cls) e.className = cls; if (text != null) e.textContent = text; return e; }
  function sv(tag, attrs, parent) { var e = document.createElementNS(SVGNS, tag); for (var k in attrs) e.setAttribute(k, attrs[k]); if (parent) parent.appendChild(e); return e; }

  var CSS = '.cks .cks-matbox{border:1px solid #E3E1DA;border-radius:14px;padding:16px 18px;display:flex;flex-direction:column;gap:12px;background:#fff}' +
    '.cks .cks-sub-h{font-size:18px;font-weight:800;margin:0;color:#1F2A30;letter-spacing:0;text-transform:none}' +
    '.cks .cks-mat-grid{display:grid;grid-template-columns:1fr 1fr;gap:12px}' +
    '.cks .cks-matc{appearance:none;-webkit-appearance:none;text-align:left;border:1px solid #CFCBC0;background:#fff;border-radius:14px;padding:14px 16px;display:flex;flex-direction:column;gap:6px;cursor:pointer;font:inherit;color:#1F2A30;margin:0;letter-spacing:0;text-transform:none;min-height:0;width:100%}' +
    '.cks .cks-matc:hover{border-color:#0B5F73}' +
    '.cks .cks-matc[aria-pressed="true"]{border:2px solid #0B5F73;background:#E4F1F4;padding:13px 15px}' +
    '.cks .cks-matc:focus-visible{outline:3px solid #C9A800;outline-offset:2px}' +
    '.cks .cks-matc-top{display:flex;justify-content:space-between;gap:8px;align-items:flex-start;font-weight:800;font-size:15px;line-height:1.3}' +
    '.cks .cks-matc-n{display:flex;align-items:center;gap:8px;flex-wrap:wrap}' +
    '.cks .cks-matc-p{white-space:nowrap}' +
    '.cks .cks-badge{background:#0B5F73;color:#fff;font-size:10.5px;font-weight:800;letter-spacing:.06em;padding:3px 8px;border-radius:999px;text-transform:uppercase;line-height:1.2}' +
    '.cks .cks-matc-d{font-size:13px;line-height:1.4;color:#4A5257;font-weight:500}' +
    '.cks .cks-sw{align-items:flex-start;text-align:left}' +
    '.cks .cks-sw .ckl-o-main{font-weight:800}' +
    '@media (max-width:600px){.cks .cks-mat-grid{grid-template-columns:1fr}.cks .cks-matbox{padding:14px}}';
  function addCss() { if (document.getElementById('cks-css')) return; var t = document.createElement('style'); t.id = 'cks-css'; t.textContent = CSS; document.head.appendChild(t); }

  function init(root) {
    addCss();
    var D;
    try { D = JSON.parse(root.querySelector('[data-cks-data]').textContent); } catch (e) { return; }
    var T = D.t || {}, P = D.prods || [];
    var st = { v: {}, mat: 0, color: 1, skirt: 0, uid: 'CK-' + Math.random().toString(36).slice(2, 8).toUpperCase(), p: null };
    if (D.fixed) st.p = { mode: D.mode, id: D.id, price: D.price, available: D.available };
    var M = MODES.s3;
    function setProd(p) { st.p = p; M = MODES[p.mode] || MODES.s2; D.mode = p.mode; }
    // XXL-Whirlpool-Cover (Handle enthält „xxl“) nutzt die Liquid-Einstellung 2-teilig, aber eigene Grenzen
    if (D.fixed && D.mode === 's2' && /xxl/i.test(location.pathname)) { st.p.mode = 'x2'; D.mode = 'x2'; }
    if (st.p) setProd(st.p);

    function money(c) {
      var f = String(D.moneyFormat || '{{amount_with_comma_separator}} €').replace(/<[^>]*>/g, '');
      function num(d, ts, ds) { var p = (c / 100).toFixed(d).split('.'); p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, ts); return p.join(ds); }
      return f.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, k) {
        if (k === 'amount_no_decimals') return num(0, ',', '.');
        if (k === 'amount_with_comma_separator') return num(2, '.', ',');
        if (k === 'amount_no_decimals_with_comma_separator') return num(0, '.', ',');
        return num(2, ',', '.');
      });
    }
    var LP = {};
    function pr(id, fb) { return LP[id] != null ? LP[id] : fb; }
    function matPrice(mi, ci) { var m = MATS[mi]; return pr(m.colors[ci == null ? 0 : ci][1], m.price); }
    function skPrice(i) { return pr(SKIRTS[i][2], SKIRTS[i][3]); }
    function plus(c) { return c ? '+ ' + money(c) : (T.incl || 'inklusive'); }

    // ---------- Prüfen ----------
    function check() {
      var res = { ok: !!st.p, msgs: {}, wide: false, warn: '' };
      if (!st.p) return res;
      M.fields.forEach(function (f) {
        var k = f[0], v = st.v[k];
        if (v == null) { res.ok = false; return; }
        if (v < f[3] || v > f[4]) { res.ok = false; res.msgs[k] = 'Bitte zwischen ' + f[3] + ' und ' + f[4] + ' cm.'; }
      });
      if (M.wideFrom && st.v.a != null && st.v.a >= M.wideFrom && st.v.a <= 260) {
        res.wide = true;
        if (!D.surchargeA) { res.ok = false; res.msgs.a = 'Für Seite A ab ' + M.wideFrom + ' cm melde dich bitte bei uns.'; }
      }
      if (M.total && st.v.b != null && st.v.c != null) {
        var t = st.v.b + st.v.c;
        if (t < M.total[0] || t > M.total[1]) res.warn = 'B + C ergibt ' + t + ' cm. Dieses Cover ist für ' + M.total[0] + '–' + M.total[1] + ' cm Gesamtlänge gedacht – bitte Maße prüfen.';
      }
      return res;
    }

    // ---------- Schritt 1: Maße ----------
    var box1 = root.querySelector('[data-cks-step="dims"]'), inputs = {}, msgs = {}, wraps = {}, gMsg, next;
    function renderDims() {
    box1.textContent = ''; inputs = {}; msgs = {}; wraps = {};
    if (!st.p) { box1.appendChild(el('p', 'ckl-note', 'Bitte wähle zuerst die Cover-Art.')); gMsg = null; next = null; return; }
    var fields = el('div', 'cks-fields');
    M.fields.forEach(function (f) {
      var k = f[0], id = root.id + '-f-' + k;
      var w = el('div', 'cks-field');
      var lb = el('label', null, f[1] + (f[2] ? ' (' + f[2] + ')' : '')); lb.htmlFor = id; w.appendChild(lb);
      var iw = el('div', 'cks-inp'), inp = el('input'); if (st.v[k] != null) inp.value = String(st.v[k]);
      inp.id = id; inp.type = 'text'; inp.inputMode = 'decimal'; inp.autocomplete = 'off'; inp.placeholder = String(M.demo[k]);
      inp.setAttribute('aria-describedby', id + '-m');
      iw.appendChild(inp); iw.appendChild(el('span', null, 'cm')); w.appendChild(iw);
      w.appendChild(el('span', 'cks-range', f[3] + '–' + f[4] + ' cm'));
      var m = el('p', 'cks-msg'); m.id = id + '-m'; m.setAttribute('aria-live', 'polite'); w.appendChild(m);
      inputs[k] = inp; msgs[k] = m; wraps[k] = iw;
      inp.addEventListener('input', function () {
        var raw = inp.value.replace(',', '.').replace(/[^\d.]/g, '');
        st.v[k] = raw === '' || isNaN(parseFloat(raw)) ? null : Math.ceil(parseFloat(raw));
        update();
      });
      inp.addEventListener('blur', function () { if (st.v[k] != null) inp.value = String(st.v[k]); });
      fields.appendChild(w);
    });
    box1.appendChild(fields);
    gMsg = el('p', 'cks-msg is-gold'); gMsg.setAttribute('aria-live', 'polite'); gMsg.hidden = true; box1.appendChild(gMsg);
    box1.appendChild(el('p', 'ckl-note', 'Immer auf den nächsten vollen Zentimeter aufrunden. Gemessen wird außen an der Oberkante.'));
    next = el('button', 'ckl-opt cks-next', 'Weiter zu Material & Farbe'); next.type = 'button'; next.disabled = true;
    box1.appendChild(next);
    }

    // ---------- Cover-Art (nur Finder-Seite) ----------
    var box0 = root.querySelector('[data-cks-step="type"]');
    function renderTypes() {
      if (!box0) return;
      box0.textContent = '';
      var grid = el('div', 'ckl-grid'); grid.style.gridTemplateColumns = '1fr';
      P.forEach(function (p) {
        var nm = NAMES[p.mode] || [p.title, ''], on = st.p && st.p.id === p.id;
        var b = el('button', 'ckl-opt cks-type'); b.type = 'button'; b.setAttribute('aria-pressed', on ? 'true' : 'false');
        var ic = document.createElementNS(SVGNS, 'svg'); ic.setAttribute('width', '64'); ic.setAttribute('height', '34'); ic.setAttribute('viewBox', '0 0 64 34'); ic.setAttribute('aria-hidden', 'true');
        sv('rect', { x: 2, y: 4, width: 60, height: 26, rx: 5, fill: '#E4F1F4', stroke: '#0B5F73', 'stroke-width': 1.6 }, ic);
        var n = (p.mode === 's2' || p.mode === 'x2') ? 2 : 3;
        for (var k = 1; k < n; k++) sv('line', { x1: 2 + 60 * k / n, y1: 4, x2: 2 + 60 * k / n, y2: 30, stroke: '#0B5F73', 'stroke-width': 1.4 }, ic);
        if (p.mode === 'z2') sv('rect', { x: 42, y: 4, width: 20, height: 26, rx: 5, fill: '#FFF3B6', stroke: '#C9A800', 'stroke-width': 1.6 }, ic);
        b.appendChild(ic);
        var col = el('span', 'ckl-o-col'), row = el('span', 'ckl-o-row');
        row.appendChild(el('span', 'ckl-o-main', nm[0])); row.appendChild(el('span', 'ckl-o-main', 'ab ' + money(p.price)));
        col.appendChild(row); col.appendChild(el('span', 'ckl-o-desc', nm[1]));
        b.appendChild(col);
        b.addEventListener('click', function () { setProd(p); renderTypes(); renderDims(); update(); });
        grid.appendChild(b);
      });
      box0.appendChild(grid);
    }

    // ---------- Schritt 2: Material & Farbe ----------
    var box2 = root.querySelector('[data-cks-step="mat"]');
    function renderMats() {
      box2.textContent = '';
      // Material: zwei Karten wie im Cover-Finder (ohne ckl-opt, damit das Akkordeon noch nicht weiterspringt)
      var c1 = el('div', 'cks-matbox'); c1.appendChild(el('p', 'cks-sub-h', 'Material'));
      var g = el('div', 'cks-mat-grid'); g.setAttribute('role', 'group'); g.setAttribute('aria-label', 'Material');
      MATS.forEach(function (m, mi) {
        var b = el('button', 'cks-matc'); b.type = 'button'; b.setAttribute('aria-pressed', st.mat === mi ? 'true' : 'false');
        var top = el('span', 'cks-matc-top'), nm = el('span', 'cks-matc-n', m.name);
        if (m.badge) nm.appendChild(el('span', 'cks-badge', m.badge));
        top.appendChild(nm); top.appendChild(el('span', 'cks-matc-p', plus(matPrice(mi))));
        b.appendChild(top); b.appendChild(el('span', 'cks-matc-d', m.desc));
        b.addEventListener('click', function () { if (st.mat !== mi) { st.mat = mi; st.color = m.def || 0; } renderMats(); update(); });
        g.appendChild(b);
      });
      c1.appendChild(g); box2.appendChild(c1);
      // Farbe: nur die Farben des gewählten Materials
      var m = MATS[st.mat], c2 = el('div', 'cks-matbox'); c2.appendChild(el('p', 'cks-sub-h', 'Farbe'));
      var grid = el('div', 'cks-sw-grid'); grid.setAttribute('role', 'group'); grid.setAttribute('aria-label', 'Farbe ' + m.name);
      m.colors.forEach(function (c, ci) {
        var on = st.color === ci;
        var b = el('button', 'ckl-opt cks-sw'); b.type = 'button'; b.setAttribute('aria-pressed', on ? 'true' : 'false');
        b.setAttribute('aria-label', m.name + ' ' + c[0]);
        var im = el('img'); im.src = IMG + c[2] + '&width=160' + m.crop; im.alt = ''; im.width = 80; im.height = 80; im.loading = 'lazy'; b.appendChild(im);
        b.appendChild(el('span', 'ckl-o-main', c[0].replace('Weather Shield ', '')));
        b.addEventListener('click', function () { st.color = ci; renderMats(); update(); });
        grid.appendChild(b);
      });
      c2.appendChild(grid); box2.appendChild(c2);
    }

    // ---------- Schritt 3: Schürze ----------
    var box3 = root.querySelector('[data-cks-step="skirt"]');
    function renderSkirts() {
      box3.textContent = '';
      var grid = el('div', 'cks-sk-grid'); grid.setAttribute('role', 'group');
      SKIRTS.forEach(function (sk, i) {
        var b = el('button', 'ckl-opt cks-sk'); b.type = 'button'; b.setAttribute('aria-pressed', st.skirt === i ? 'true' : 'false');
        b.appendChild(el('span', 'ckl-o-main', sk[1]));
        b.appendChild(el('span', 'ckl-o-sub', plus(skPrice(i))));
        b.addEventListener('click', function () { st.skirt = i; renderSkirts(); update(); });
        grid.appendChild(b);
      });
      box3.appendChild(grid);
      box3.appendChild(el('p', 'ckl-note', 'Die Schürze ist der seitliche Rand, der über die Außenkante fällt. Standard sind ca. 15 cm.'));
    }

    // ---------- Vorschau ----------
    var svg = root.querySelector('[data-cks-svg]');
    function drawPreview(chk) {
      if (!svg) return;
      while (svg.firstChild) svg.removeChild(svg.firstChild);
      var v = {}; M.fields.forEach(function (f) { v[f[0]] = (st.v[f[0]] != null && !chk.msgs[f[0]]) ? st.v[f[0]] : M.demo[f[0]]; });
      var len = v.b + (v.c || 0), W = 250, H = 120;
      var sc = Math.min(W / len, H / v.a), w = len * sc, h = v.a * sc;
      var x0 = 46 + (W - w) / 2, y0 = 22 + (H - h) / 2, rr = Math.min(v.r * sc, h / 2, 30);
      var col = MATS[st.mat].colors[st.color], tex = IMG + col[2] + '&width=240' + MATS[st.mat].crop;
      var defs = sv('defs', {}, svg), pid = root.id + '-tex';
      var pat = sv('pattern', { id: pid, patternUnits: 'userSpaceOnUse', width: 90, height: 90 }, defs);
      var pim = sv('image', { x: 0, y: 0, width: 90, height: 90, preserveAspectRatio: 'xMidYMid slice' }, pat);
      pim.setAttributeNS('http://www.w3.org/1999/xlink', 'href', tex); pim.setAttribute('href', tex);
      sv('rect', { x: x0 + 3, y: y0 + 4, width: w, height: h, rx: rr, fill: '#1F2A30', opacity: '.12' }, svg);
      sv('rect', { x: x0, y: y0, width: w, height: h, rx: rr, fill: 'url(#' + pid + ')', stroke: '#1F2A30', 'stroke-width': 1.4 }, svg);
      // Teilungen: Nähte (durchgezogen) und Faltkanten (gestrichelt)
      var seams = [], folds = [];
      if (D.mode === 'z2') { seams = [v.b / 2, v.b]; folds = [v.b / 4, v.b * 3 / 4, v.b + v.c / 2]; }
      else if (D.mode === 'x2') {
        // XXL: bei 1/3 klappbar verbunden, bei 2/3 geteilt mit Überhang-Lasche
        folds = [len / 3];
        var xl = x0 + len * 2 / 3 * sc;
        sv('rect', { x: xl - 3, y: y0, width: 6, height: h, fill: '#1F2A30', opacity: '.55' }, svg);
        seams = [len * 2 / 3];
      }
      else { for (var k = 1; k < M.parts; k++) seams.push(len * k / M.parts); for (var j = 0; j < M.parts; j++) folds.push(len * (j + 0.5) / M.parts); }
      seams.forEach(function (s) { sv('line', { x1: x0 + s * sc, y1: y0, x2: x0 + s * sc, y2: y0 + h, stroke: '#1F2A30', 'stroke-width': 1.6 }, svg); });
      folds.forEach(function (s) { sv('line', { x1: x0 + s * sc, y1: y0 + 3, x2: x0 + s * sc, y2: y0 + h - 3, stroke: '#fff', 'stroke-width': 1.2, 'stroke-dasharray': '4 3', opacity: '.85' }, svg); });
      if (D.mode === 'z2') {
        sv('line', { x1: x0 + v.b * sc, y1: y0 - 6, x2: x0 + v.b * sc, y2: y0 + h + 6, stroke: '#C9A800', 'stroke-width': 2.4 }, svg);
        var zs = { 'font-size': 10.5, 'font-weight': 800, fill: '#fff', 'text-anchor': 'middle', stroke: '#1F2A30', 'stroke-width': 3, 'paint-order': 'stroke', 'stroke-linejoin': 'round' };
        zs.x = x0 + v.b * sc / 2; zs.y = y0 + h - 8; sv('text', zs, svg).textContent = 'Swim-Spa-Bereich';
        zs.x = x0 + (v.b + v.c / 2) * sc; sv('text', zs, svg).textContent = 'Whirlpool';
      }
      // Eckradius oben rechts
      if (rr > 2) sv('path', { d: 'M' + (x0 + w - rr) + ' ' + y0 + ' A' + rr + ' ' + rr + ' 0 0 1 ' + (x0 + w) + ' ' + (y0 + rr), fill: 'none', stroke: '#C9A800', 'stroke-width': 4, 'stroke-linecap': 'round' }, svg);
      function lab(x, y, txt, anchor, rot) {
        var t = sv('text', { x: x, y: y, 'font-size': 12.5, 'font-weight': 800, fill: '#1F2A30', 'text-anchor': anchor || 'middle', stroke: '#fff', 'stroke-width': 4, 'paint-order': 'stroke', 'stroke-linejoin': 'round' }, svg);
        if (rot) t.setAttribute('transform', 'rotate(-90 ' + x + ' ' + y + ')');
        t.textContent = txt; return t;
      }
      function dim(x1, y1, x2, y2) {
        var c = '#0B5F73';
        sv('line', { x1: x1, y1: y1, x2: x2, y2: y2, stroke: c, 'stroke-width': 1.5 }, svg);
        if (x1 === x2) { sv('line', { x1: x1 - 5, y1: y1, x2: x1 + 5, y2: y1, stroke: c, 'stroke-width': 1.5 }, svg); sv('line', { x1: x1 - 5, y1: y2, x2: x1 + 5, y2: y2, stroke: c, 'stroke-width': 1.5 }, svg); }
        else { sv('line', { x1: x1, y1: y1 - 5, x2: x1, y2: y1 + 5, stroke: c, 'stroke-width': 1.5 }, svg); sv('line', { x1: x2, y1: y1 - 5, x2: x2, y2: y1 + 5, stroke: c, 'stroke-width': 1.5 }, svg); }
      }
      function fmt(k) { return k.toUpperCase() + ': ' + (st.v[k] != null && !chk.msgs[k] ? st.v[k] + ' cm' : '?'); }
      dim(x0 - 14, y0, x0 - 14, y0 + h); lab(x0 - 20, y0 + h / 2, fmt('a'), 'middle', true);
      var yb = y0 + h + 16;
      if (D.mode === 'z2') {
        dim(x0, yb, x0 + v.b * sc, yb); lab(x0 + v.b * sc / 2, yb + 18, fmt('b'));
        dim(x0 + v.b * sc, yb, x0 + w, yb); lab(x0 + (v.b + v.c / 2) * sc, yb + 18, fmt('c'));
      } else { dim(x0, yb, x0 + w, yb); lab(x0 + w / 2, yb + 18, fmt('b')); }
      var rt = lab(Math.min(x0 + w + 4, 316), y0 - 6, 'r: ' + (st.v.r != null && !chk.msgs.r ? st.v.r + ' cm' : '?'), 'end');
      rt.setAttribute('fill', '#5C4B00'); rt.setAttribute('font-size', '11.5');
    }

    // ---------- Gesamt ----------
    var sum = root.querySelector('[data-ckl-sum]'), ack = root.querySelector('[data-cks-ack]'), add = root.querySelector('[data-cks-add]');
    var hint = root.querySelector('[data-cks-hint]'), err = root.querySelector('[data-cks-err]');
    function dimText(chk) {
      if (!chk.ok) return '–';
      var p = ['A: ' + st.v.a + ' cm', 'B: ' + st.v.b + ' cm'];
      if (st.v.c != null && D.mode === 'z2') p.push('C: ' + st.v.c + ' cm');
      p.push('r: ' + st.v.r + ' cm');
      return p.join(' · ');
    }
    function total(chk) {
      var t = (st.p ? st.p.price : (P[0] ? P[0].price : D.price)) + matPrice(st.mat, st.color) + skPrice(st.skirt);
      if (chk.wide && D.surchargeA) t += D.surchargeAPrice;
      return t;
    }
    function update() {
      var chk = check();
      if (st.p) M.fields.forEach(function (f) {
        var k = f[0], has = st.v[k] != null, bad = !!chk.msgs[k];
        wraps[k].classList.toggle('is-bad', bad); wraps[k].classList.toggle('is-ok', has && !bad);
        msgs[k].textContent = chk.msgs[k] || ''; msgs[k].classList.toggle('is-bad', bad);
        inputs[k].setAttribute('aria-invalid', bad ? 'true' : 'false');
      });
      var gm = [];
      if (chk.wide && D.surchargeA) gm.push('Seite A ab ' + M.wideFrom + ' cm: Aufpreis ' + money(D.surchargeAPrice) + '.');
      if (chk.warn) gm.push(chk.warn);
      if (gMsg) { gMsg.textContent = gm.join(' '); gMsg.hidden = !gm.length; }
      if (next) next.disabled = !chk.ok;
      root.querySelectorAll('[data-cks-fact]').forEach(function (f) { var fm = f.getAttribute('data-cks-fact'); f.hidden = !(fm === 'all' || (st.p && fm === st.p.mode)); });

      var m = MATS[st.mat], c = m.colors[st.color], sk = SKIRTS[st.skirt];
      var rows = [];
      if (!D.fixed) rows.push(['Cover-Art', st.p ? (NAMES[st.p.mode] || [''])[0] : '–']);
      rows = rows.concat([['Maße', dimText(chk)], ['Material & Farbe', m.name + ' · ' + c[0].replace('Weather Shield ', '')], ['Schürze', sk[1]]]);
      if (chk.wide && D.surchargeA) rows.push(['Aufpreis Seite A', money(D.surchargeAPrice)]);
      if (sum) {
        sum.textContent = '';
        rows.forEach(function (r) { var d = el('div'); d.appendChild(el('dt', null, r[0])); d.appendChild(el('dd', null, r[1])); sum.appendChild(d); });
      }
      var price = (st.p ? '' : 'ab ') + money(total(chk));
      root.querySelectorAll('[data-cks-price]').forEach(function (p) { p.textContent = price; });
      var ml = root.querySelector('[data-cks-matline]'); if (ml) ml.textContent = m.name + ' · ' + c[0].replace('Weather Shield ', '');
      var bl = root.querySelector('[data-cks-barline]'); if (bl) bl.textContent = chk.ok ? dimText(chk) + ' · ' : '';
      var chips = root.querySelector('[data-cks-chips]');
      if (chips) { chips.textContent = ''; [m.name, c[0].replace('Weather Shield ', ''), 'Schürze ' + sk[1]].forEach(function (t) { chips.appendChild(el('span', 'ckl-chip', t)); }); }
      drawPreview(chk);
      var ready = chk.ok && st.p && st.p.available !== false;
      add.disabled = !(ready && ack && ack.checked);
      if (hint) hint.hidden = ready && ack && ack.checked;
      if (hint && !st.p) hint.textContent = 'Bitte wähle zuerst die Cover-Art.';
      else if (hint && !chk.ok) hint.textContent = 'Bitte gib alle Maße ein.';
      else if (hint) hint.textContent = 'Bitte bestätige noch die Angaben.';
      return chk;
    }
    if (ack) ack.addEventListener('change', function () { if (err) err.hidden = true; update(); });

    // ---------- Warenkorb ----------
    add.addEventListener('click', function () {
      var chk = update(); if (add.disabled || !chk.ok) return;
      var m = MATS[st.mat], c = m.colors[st.color], sk = SKIRTS[st.skirt];
      var wide = chk.wide && D.surchargeA;
      var pre = (D.mode === 's3' && wide) ? '_Größe 2-' : '_Größe 1-';
      var p = {};
      p['A'] = st.v.a + ' cm'; p['B'] = st.v.b + ' cm';
      if (D.mode === 'z2') p['C'] = st.v.c + ' cm';
      p['Radius'] = st.v.r + ' cm';
      p['Material'] = m.name + ' ' + c[0].replace('Weather Shield ', '');
      p['Schürze'] = sk[1];
      p['Lieferzeit'] = T.lead || '';
      if (D.mode === 's3') p['_Cover Größe Seite A'] = wide ? 'Länge A 236 bis 260 cm / Länge B 460 - 690 cm' : 'Länge A bis 235 / Länge B 460 - 690 cm';
      p[pre + 'Länge A'] = st.v.a + ' cm'; p[pre + 'Länge B'] = st.v.b + ' cm';
      if (D.mode === 'z2') { p['_Größe 1-Länge C'] = st.v.c + ' cm'; p['_Radius-Radius'] = String(st.v.r); }
      else p[pre + 'Radius'] = st.v.r + ' cm';
      p['_Wähle die Farbe und das Material'] = m.group;
      p[m.prop] = c[0];
      p['_Skirt Lenght'] = sk[0];
      p['_Lieferzeit (1)'] = 'Individuelle Produktion I Lieferung in ca. 30 Werktagen';
      p['_Bestätigung Maßanfertigung (1)'] = T.ack || '';
      p['_Cover-ID'] = st.uid; p['_bundle_id'] = st.uid; p['_is_parent'] = 'true';
      var link = { 'Für Cover': st.uid, '_Cover-ID': st.uid, '_bundle_id': st.uid, '_bundle_child': 'true' };
      var items = [{ id: st.p.id, quantity: 1, properties: p }, { id: c[1], quantity: 1, properties: link }, { id: sk[2], quantity: 1, properties: link }];
      if (wide) items.push({ id: D.surchargeA, quantity: 1, properties: link });
      var label = add.textContent; add.disabled = true; add.textContent = T.adding || label; if (err) err.hidden = true;
      var base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      fetch(base + 'cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
        .then(function () { location.href = base + 'cart'; })
        .catch(function (e) {
          add.textContent = label; add.disabled = false;
          if (err) { err.textContent = (e && e.description) || T.cart_error || 'Fehler'; err.hidden = false; }
        });
    });

    // ---------- Info-Fenster ----------
    root.querySelectorAll('[data-ckl-info]').forEach(function (b) {
      var dlg = document.getElementById(b.getAttribute('data-ckl-info'));
      if (!dlg) return;
      if (dlg.parentNode !== document.body) document.body.appendChild(dlg);
      var body = dlg.querySelector('.ckl-dlg-body'), loaded = false;
      function load() {
        var url = body && body.getAttribute('data-ckl-fetch'); if (!url || loaded) return; loaded = true;
        var msg = body.querySelector('[data-ckl-msg]'), sel = body.getAttribute('data-ckl-select');
        fetch(url, { credentials: 'same-origin' }).then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); }).then(function (t) {
          var doc = new DOMParser().parseFromString(t, 'text/html'), nodes = [].slice.call(doc.querySelectorAll(sel));
          if (!nodes.length) throw new Error('none');
          var wrap = el('div', 'ckl-dlg-rte');
          nodes.forEach(function (nd) {
            nd.querySelectorAll('script').forEach(function (s) { s.remove(); });
            var host = nd.parentElement, keep = null;
            while (host) { if (host.id && host.querySelector(':scope > style')) { keep = host; break; } host = host.parentElement; }
            if (keep) {
              var shell = document.createElement(keep.tagName); shell.id = keep.id; shell.className = (keep.className ? keep.className + ' ' : '') + 'ckl-dlg-host';
              keep.querySelectorAll(':scope > style').forEach(function (s2) { shell.appendChild(document.importNode(s2, true)); });
              shell.appendChild(document.importNode(nd, true));
              wrap.appendChild(shell);
            } else {
              var prev = nd.previousElementSibling;
              if (prev && prev.tagName === 'STYLE') wrap.appendChild(document.importNode(prev, true));
              wrap.appendChild(document.importNode(nd, true));
            }
          });
          if (msg) msg.replaceWith(wrap); else body.insertBefore(wrap, body.firstChild);
        }).catch(function () { loaded = false; if (msg) msg.textContent = body.getAttribute('data-ckl-error') || ''; });
      }
      b.addEventListener('click', function () {
        if (typeof dlg.showModal !== 'function') { var a = dlg.querySelector('.ckl-dlg-more a'); if (a) location.href = a.href; return; }
        dlg.showModal(); load();
      });
      dlg.querySelectorAll('[data-ckl-close]').forEach(function (x) { x.addEventListener('click', function () { dlg.close(); }); });
      dlg.addEventListener('click', function (e) { if (e.target === dlg) dlg.close(); });
      dlg.addEventListener('close', function () { b.focus(); });
    });

    renderTypes(); renderDims(); renderMats(); renderSkirts(); update();
    var base0 = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    Promise.all(HANDLES.map(function (h) {
      return fetch(base0 + 'products/' + h + '.js', { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.json() : null; }).then(function (j) {
        if (j && j.variants) j.variants.forEach(function (v) { LP[v.id] = v.price; });
      }).catch(function () {});
    })).then(function () { renderMats(); renderSkirts(); update(); });
  }

  function boot() { document.querySelectorAll('[data-cks]').forEach(function (r) { if (!r.__cks) { r.__cks = true; init(r); } }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
